import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  Router,
  TitleStrategy,
  withHashLocation,
} from '@angular/router';
import { loadingInterceptor } from '@interceptors/loading.interceptor';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { authInterceptor } from '@interceptors/auth.interceptor';
import { AppTitleStrategy } from './strategies/title.strategy';
import { PendingChangesGuard } from '@guards/pending-changes.guard';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import {
  ChunkErrorHandlerService,
  SESSION_KEY_COUNT,
  SESSION_KEY_DESTINATION,
} from '@services/chunk-error-handler.service';

function chunkRecoveryInitializerFactory(router: Router): () => Promise<void> {
  return async () => {
    try {
      const destination = sessionStorage.getItem(SESSION_KEY_DESTINATION);
      sessionStorage.removeItem(SESSION_KEY_DESTINATION);
      sessionStorage.removeItem(SESSION_KEY_COUNT);
      if (!destination) {
        return;
      }
      await router.navigateByUrl(destination);
    } catch {
      // Recovery navigation failed; fall through to default startup
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: ChunkErrorHandlerService },
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideToastr({ positionClass: 'toast-bottom-left' }),
    PendingChangesGuard,
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, loadingInterceptor])),
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: chunkRecoveryInitializerFactory,
      deps: [Router],
      multi: true,
    },
  ],
};
